import * as React from "react";
import AnomalyEventSummary from "./AnomalyEventSummary";
const AnomalyEventSummaryContainer = ({
  config,
  entityScope = void 0
}) => /* @__PURE__ */ React.createElement(AnomalyEventSummary, { config, entityScope });
export default AnomalyEventSummaryContainer;
